export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Initialization error",
    "StaticConfigLoader.caption.init": "Initialization",
    "StaticConfigLoader.text.init": "Initializing application...",
    "StaticConfigLoader.error.settings": "Unable to load site settings",
    "StaticConfigLoader.error.circuits": "Unable to load services config",
    //app
    "Legal.Localization": "en",
    "AchievementApp.Navbar.storeTitle": "Store",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Terms and Conditions",
    "Legal.TermsService": "Terms of Service",
    "Legal.PrivacyPolicy": "Privacy Policy",
    "Legal.CookiesPolicy": "Cookie Settings",
    "Legal.Copyright": "All trademarks, logos and brand names are the property of their respective owners.",
    "AchievementApp.Navbar.achievement": "Personal achievements",
    "AchievementApp.Navbar.userAchievement": "User achievements",
    "AchievementApp.Navbar.settingsLink": "Settings",
    "AchievementApp.Navbar.profileLink": "Profile",
    "AchievementApp.Navbar.reloginLink": "Relogin or change account",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Completed",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filter by titles",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "My friends",
    "UserFriendsList.heading.showMore": "Show more",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "You need to configure two-factor authorization",
    "LimitedAccountPanel.2step.link": "More about two-factor authorization",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "You need to confirm your email address",
    "LimitedAccountPanel.email.link": "Proceed to profile",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Your account is limited due to:",
    "LimitedAccountPanel.conclusion": "After changing the security settings, you should log out and log in to make the changes take effect",
    "LimitedAccountPanel.relogin": "Relogin...",
    "EmailVerificationStateIcon.success": "Confirmed account, email verified",
    "EmailVerificationStateIcon.warning": "Unconfirmed account, email not verified",
    "EmailVerificationStateIcon.danger": "Unconfirmed account, email verification REQUIRED",
    "TwoFactorStateIcon.success": "Account secured with two-factor authorization",
    "TwoFactorStateIcon.warning": "Insecure account, two-factor authorization disabled",
    "TwoFactorStateIcon.danger": "Two-factor authorization REQUIRED",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Save settings",
    "UserSettingDialog.settings": "Settings",
    "UserSettingDialog.userSettings": "User settings",
    "UserSettingDialog.language": "Language",
    "UserSettingDialog.privacy": "Privacy",
    "UserSettingDialog.allUsers": "All users",
    "UserSettingDialog.friendsOnly": "Friends only",
    "UserSettingDialog.onlyMe": "Only me",
    "UserSettingDialog.whoCanView": "Who can view my achievements",
    //unlockProgress
    "ViewUnlockProgress.of": " of ",
    "ViewUnlockProgress.achievCompleted": " achievements completed ",
    "ViewUnlockProgress.myUnlock": "My Achievements ",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Search nick here",
    "ViewItemSearch.label.search": "Search for users",
    "ViewItemSearch.resultNotFound": "User not found",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Achievements",
    "ViewItemSearch.stub.empty": "No achievements",
    "ViewItemSearch.stub.emptyCompare_1": "User ",
    "ViewItemSearch.stub.emptyCompare_2": " has no achievements in this game",
    "ViewItemSearch.limitedAccess": "Access to the achievements of the selected user is limited",
    "ViewItemSearch.heading.selectGame": "Select game from list",
    "ViewItemSearch.globalstat.opened": "unlocked by ",
    "ViewItemSearch.globalstat.ofGamers": "% of gamers",
    //authentication
    "NotAllowedMessage.caption": "Not allowed",
    "NotAllowedMessage.body.h1": "Access to Achievements",
    "NotAllowedMessage.body.h3": "currently not allowed for your account",
    "NotAllowedMessage.relogin": "Change account",
    "LandingMessage.caption": "Authentication",
    "LandingMessage.body": "Finishing landing...",
    "TokenExpiredMessage.caption": "Authentication expired",
    "TokenExpiredMessage.body.h3": "There's not much we can do with this, but you can still",
    "TokenExpiredMessage.relogin": "Relogin...",
    "AuthErrorMessage.caption": "Authentication failed",
    "AuthErrorMessage.body.h1": "Failed to check authentication",
    "AuthErrorMessage.body.code": "Code:",
    "AuthErrorMessage.body.desc": "There's not much we can do with this, but you can still",
    "AuthErrorMessage.relogin": "Relogin...",
    "AuthorizationRequiredMessage.caption": "Authentication required",
    "AuthorizationRequiredMessage.body.h3.1": "You are about to enter",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "But you need to be authorized to proceed further",
    "AuthorizationRequiredMessage.login": "Sign-in with Gaijin.Net",
    "CheckingAuthMessage.caption": "Authentication",
    "CheckingAuthMessage.body": "Checking authentication, please be patient",
    "AuthorizationRequiredMessageMobile.body.h3.1": "The mobile version is temporarily unavailable",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Please use the computer version",
    "AuthorizationRequiredMessageMobile.body.h3.3": "We apologize",
}